module.exports = __webpack_public_path__ + "static/media/angle-down-solid.8bad8773.svg";